import { useEffect, useState } from "react";

function useMobileCheck() {
	const getWidth = () => (typeof window !== "undefined" ? window.innerWidth : 1024);
	const [windowSize, setWindowSize] = useState(getWidth);
	const [isMobile, setIsMobile] = useState(() => getWidth() < 768);

	useEffect(() => {
		const handleResize = () => {
			setWindowSize(window.innerWidth);
			if (window.innerWidth < 768) {
				setIsMobile(true);
			} else {
				setIsMobile(false);
			}
		};
		window.addEventListener("resize", handleResize);
		handleResize();
		return () => window.removeEventListener("resize", handleResize);
	}, []);

	return { isMobile, windowSize };
}

export default useMobileCheck;
